import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBriefcase,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BusinessVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Business Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Business</Subheading>}
        heading={
          <Heading>
            Business <span tw="text-primary-500">Video Production</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in business video production in
            **Bur Dubai**, creating professional, engaging videos that
            strengthen your brand and communicate your business goals
            effectively.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551817958-c5b51e7b4a33?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional video camera setup
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video production team at work
          "https://images.unsplash.com/photo-1578574577315-3fbeb0cecdc2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Modern business skyline in Dubai
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Business Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Professional Business Videos in Bur Dubai"
        description="We craft business videos that drive results."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Brand Enhancement",
            description: "Videos that reflect your business’s professionalism.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Compelling stories to connect with your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Delivery",
            description: "Fast production to meet your business needs.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Versatile Formats",
            description:
              "Videos optimized for websites, social media, and pitches.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Partner",
            description: "Bur Dubai’s choice for business video production.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored videos for marketing, training, or events.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Business Video Production Process"
        description={
          <Description>
            We create impactful business videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your business objectives and audience.
              </li>
              <li>Scripting: Develop a clear, goal-oriented narrative.</li>
              <li>
                Filming: Capture professional visuals with high-end equipment.
              </li>
              <li>
                Editing: Enhance with branding, effects, and audio design.
              </li>
              <li>Delivery: Provide polished videos ready for deployment.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039710-0f49c0a47eb7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1522152716425-ec958d91dbf2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
          "https://images.unsplash.com/photo-1581591524425-c7e0978865fc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video production planning meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Business Video Wins in Bur Dubai"
        description="Our business videos have empowered brands."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Stronger Branding",
            description: "Elevated business identity with professional videos.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from Bur Dubai businesses.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Higher Engagement",
            description: "Increased interaction with targeted content.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow Your Business?</Subheading>}
        heading="Business Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert business video production in
            Bur Dubai. Get professional, results-driven videos to amplify your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1513759565286-20e9c5fad06b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai business district skyline
          "https://images.unsplash.com/photo-1528109966604-5a6a3a443625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional videographer with equipment
          "https://images.unsplash.com/photo-1569159316193-42ecbf194bad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Corporate video interview setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
